import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { getSortIcon } from './chirpResultsHelpers'

const SortableColumnHeader = ({ label, column, sortState, onSort }) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onSort()
    }
  }

  return (
    <th className="is-selected has-text-centered is-nowrap">
      {label}
      <span
        className="is-clickable pl-1"
        role="button"
        tabIndex={0}
        onClick={onSort}
        onKeyDown={handleKeyDown}
        aria-label={`Sort by ${label}`}
      >
        <FontAwesomeIcon icon={getSortIcon(column, sortState)} />
      </span>
    </th>
  )
}

export default SortableColumnHeader
